import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import Colors from '../resource/ResourceColors.jsx';

const FileListContainer = styled.div`
    margin: 0.25rem 1rem;
    display: block;
    padding: 0.5rem;
    border-radius: 0.25rem;
    max-height: 15rem;
    overflow: auto;
    border: 0.15rem solid white;
    background: ${Colors.right_diagonal_gradient(100, 90)};
    box-shadow: inset ${Colors.wide_raw_shadow(8)}, ${Colors.extra_wide_raw_shadow(18)}, ${Colors.extra_wide_raw_shadow(8, true)}; 
`;

const FileListRow = styled.div`
    display: inline-block;
    width: 92%;
    height: 1.25rem;
    color: ${Colors.primary(40)};
    padding: 0.05rem 0.5rem;
    border-radius: 0.2rem;
`;

const FileListIcon = styled.div`
    float: left;
    margin-right: 0.25rem;
    filter: ${Colors.tight_shadow(40)};
`;

const FileListText = styled.div`
    margin-top: 0.25rem;
    font-size: 0.75rem;
    font-weight: bold;
    text-shadow: ${Colors.medium_text_shadow(20)};
`;

export class InterfaceIconList extends Component {

    static propTypes = {
        rows: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            text: PropTypes.string.isRequired,
            text_style: PropTypes.object,
            icon: PropTypes.element.isRequired,
            icon_style: PropTypes.object
        })).isRequired
    }

    state = {
        remote_path: ''
    };

    mouse_out_row(ref) {
        const element = ref.current;
        element.style.background = null;
        element.style.color = Colors.primary(40);
        element.style.textShadow = null;
        element.style.boxShadow = null;
    }

    mouse_over_row(ref) {
        const element = ref.current;
        element.style.background = Colors.right_diagonal_gradient(80, 60);
        element.style.color = 'white';
        element.style.textShadow = Colors.medium_text_shadow(50);
        element.style.boxShadow = Colors.medium_shadow(30);
    }

    on_click_row(name, id_prefix) {
        if (id_prefix === 'folder') {
            console.log('clicked on folder');
        }
    }

    render() {
        const rows = this.props.rows.map((row, key) => {
            const ref = React.createRef();
            return <FileListRow
                key={'iconlist-' + key}
                ref={ref}
                onClick={(e) => this.on_click_row(row.id)}
                onMouseOut={(e) => this.mouse_out_row(ref)}
                onMouseOver={(e) => this.mouse_over_row(ref)}>
                <FileListIcon style={row.icon_style}>{row.icon}</FileListIcon>
                <FileListText style={row.text_style}>{row.text}</FileListText>
            </FileListRow>
        });
        return <FileListContainer>
            {rows}
        </FileListContainer>
    }

}

export default InterfaceIconList;